/**
 * Career Portal promotion section on the marketing homepage.
 * Deep-links to the isolated Careers app at /careers.
 */
import { Link } from 'react-router-dom';
import {
  Sparkles, FileText, TrendingUp, Award, Globe, ArrowRight,
} from 'lucide-react';

const HIGHLIGHTS = [
  { icon: Sparkles, title: 'AI Resume Analysis', text: 'Get an instant ATS score, keyword gaps and personalised improvement suggestions.' },
  { icon: FileText,  title: 'Premium Career Report', text: 'A professionally designed PDF you can share with recruiters and mentors.' },
  { icon: TrendingUp, title: 'ATS Optimisation', text: 'See exactly where your resume fails automated screening — and how to fix it.' },
  { icon: Award,      title: 'Career Guidance', text: 'A complimentary 1-on-1 counselling session with our team included with Premium.' },
];

export default function CareerPortalSection() {
  return (
    <section className="ee-section career-portal-section" data-testid="career-portal-section" style={{
      background: 'linear-gradient(135deg, #050d1f 0%, #0a1628 60%, #0a1628 100%)',
      color: '#f5f2ea',
      padding: '90px 0',
      position: 'relative',
      overflow: 'hidden',
    }}>
      <div className="container">
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: 48, alignItems: 'center',
        }}>
          <div>
            <div style={{
              display: 'inline-block', padding: '6px 14px', borderRadius: 999,
              background: 'rgba(212,168,73,0.12)', border: '1px solid rgba(212,168,73,0.4)',
              color: '#f5d488', fontSize: 12, letterSpacing: '0.18em',
              textTransform: 'uppercase', fontWeight: 700, marginBottom: 16,
            }}>
              <Globe size={12} style={{ marginRight: 6, verticalAlign: 'middle' }} />
              EuroElite Career Portal
            </div>
            <h2 style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: 'clamp(32px, 4vw, 46px)',
              fontWeight: 600, lineHeight: 1.15, margin: 0, color: '#ffffff',
            }}>
              Launch Your <span style={{ color: '#d4a849', fontStyle: 'italic' }}>Global Career.</span>
            </h2>
            <p style={{
              marginTop: 18, fontSize: 16, lineHeight: 1.7,
              color: 'rgba(245,242,234,0.75)', maxWidth: 560,
            }}>
              Looking for jobs or study opportunities in Europe or India? Create your
              professional profile, upload your resume, receive an AI-powered career
              analysis, and explore global education and career opportunities through
              the EuroElite Career Portal.
            </p>
            <div style={{ display: 'flex', gap: 14, marginTop: 28, flexWrap: 'wrap' }}>
              <Link
                to="/careers"
                data-testid="home-career-portal-cta"
                style={{
                  display: 'inline-flex', alignItems: 'center', gap: 8,
                  background: '#d4a849', color: '#0a1628',
                  padding: '14px 26px', borderRadius: 10, fontWeight: 700,
                  fontSize: 14, letterSpacing: '0.02em', textDecoration: 'none',
                  transition: 'all 0.25s ease',
                }}
              >
                Explore Career Portal <ArrowRight size={16} />
              </Link>
              <Link
                to="/careers/premium"
                data-testid="home-career-premium-link"
                style={{
                  display: 'inline-flex', alignItems: 'center', gap: 8,
                  border: '1px solid rgba(212,168,73,0.5)', color: '#f5d488',
                  padding: '14px 22px', borderRadius: 10, fontWeight: 600,
                  fontSize: 14, textDecoration: 'none',
                }}
              >
                See Premium Report
              </Link>
            </div>
          </div>

          <div style={{
            display: 'grid', gap: 16,
            gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
          }}>
            {HIGHLIGHTS.map(({ icon: Icon, title, text }) => (
              <div key={title} style={{
                padding: 20, borderRadius: 14,
                background: 'rgba(255,255,255,0.03)',
                border: '1px solid rgba(212,168,73,0.18)',
                backdropFilter: 'blur(8px)',
              }}>
                <div style={{
                  width: 42, height: 42, borderRadius: 10,
                  background: 'rgba(212,168,73,0.12)',
                  border: '1px solid rgba(212,168,73,0.3)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: '#d4a849', marginBottom: 12,
                }}>
                  <Icon size={20} />
                </div>
                <h4 style={{ margin: '0 0 6px', color: '#f5d488', fontSize: 15, fontWeight: 700 }}>
                  {title}
                </h4>
                <p style={{ margin: 0, fontSize: 13.5, lineHeight: 1.55, color: 'rgba(245,242,234,0.7)' }}>
                  {text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
